import {
  Create,
  Box,
  TextField,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormHelperText,
} from "@pankod/refine-mui";
import { Controller, useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  user_id: Yup.number().required(),
  is_added: Yup.boolean().required(),
  amount: Yup.number().required(),
  reason: Yup.string().trim().required(),
});

interface formDataType {
  user_id: number;
  is_added: boolean;
  amount: number;
  reason: string;
}

export const CreditCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("user_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.user_id}
          helperText={(errors as any)?.user_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="User_id"
          name="user_id"
        />
        <Controller
          control={control}
          name="is_added"
          render={({ field: { onChange, value } }) => (
            <FormControl required error={!!(errors as any)?.is_added}>
              <FormLabel>Is_added</FormLabel>
              <RadioGroup
                row
                onChange={(_, value) => onChange(value === "true")}
                value={value}
              >
                <FormControlLabel
                  control={<Radio />}
                  label="True"
                  value={true}
                />
                <FormControlLabel
                  control={<Radio />}
                  label="False"
                  value={false}
                />
              </RadioGroup>
              <FormHelperText>
                {(errors as any)?.is_added?.message}
              </FormHelperText>
            </FormControl>
          )}
        />
        <TextField
          {...register("amount", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.amount}
          helperText={(errors as any)?.amount?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Amount"
          name="amount"
        />
        <TextField
          {...register("reason", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.reason}
          helperText={(errors as any)?.reason?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Reason"
          name="reason"
        />
      </Box>
    </Create>
  );
};
